/*

 Click and touch events helpers

 */

function click_touch_init() {

    $(document).on("click.touchfocused", ".touchevents .js-touch-focused, .js-touch-focused-all", function (e) {
        var $o = $(this);
        if (!$o.hasClass("focused")) {
            if (!$o.hasClass("disable-prevent-link-clicks")) {
                e.preventDefault();
            }
            $(".js-touch-focused").not($o).not($o.closest(".js-touch-focused")).removeClass("focused");
            $o.addClass("focused");
        } else {
            if ($o.hasClass('js-touch-focused-toggle')) {
                $o.removeClass("focused");
            }
        }
    });

    $(document).on("click", ".touchevents .js-touch-focused a, .js-touch-focused-all a", function (e) {
        var $tf = $(this).closest(".js-touch-focused");
        if (!$tf.hasClass("focused") && !$tf.hasClass("disable-prevent-link-clicks")) {
            e.preventDefault();
        }
    });

    $(document).on("click touchstart", "*", function (e) {
        if (!$(e.target).closest(".js-touch-focused").length) {
            $(".js-touch-focused").removeClass("focused");
        }
    });

    $(document).on("click", ".js-prevent-default", function (e) {
        e.preventDefault();
    });

    $(document).on("click", ".js-stop-propagation", function (e) {
        e.stopPropagation();
    });

}



/*

Fix buggy 100vh behaviour on mobiles

 */

function fix_100vh_init() {
    if (!Modernizr.touchevents) return;

    fix_100vh();
    $("body").data("fix_100vh_ww", $(window).width());

    $(window).on("resize", function (e) {
        if ($("body").data("fix_100vh_ww") != $(window).width()) {
            fix_100vh();
        }
        $("body").data("fix_100vh_ww", $(window).width());
    });
}

function fix_100vh() {
    $(".js-fix-100vh").each(function(){
        $(this).css("height", window.innerHeight);
    });
    $(".js-fix-100vh-minus-header").each(function(){
        $(this).css("height", window.innerHeight - $('.header + .header-replace')[0].offsetHeight);
    });
    $(".js-fix-100vh-min").each(function(){
        $(this).css("min-height", window.innerHeight);
    });
    $(".js-fix-100vh-max").each(function(){
        $(this).css("max-height", window.innerHeight);
    });
}


/*

Responsive design helpers

 */

function responsive_init() {
    responsive_update();
}

function responsive_update(force, no_animation) {
    if (typeof no_animation !== 'undefined' && no_animation) {
        $("body").addClass('no-transition no-animation');
    }
    if (typeof force === "undefined") force = false;
    var ww = window.innerWidth;
    if ($("body").data("ww") != ww || force) {
        if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
            Blazy.revalidate();
        }
        $("[data-place]").each(function () {
            var places = $(this).data("place");
            var breakpoints = Object.keys(places).map(function (value) {
                return parseInt(value);
            }).sort(function (a, b) {
                return a - b;
            }).reverse();
            for (i in breakpoints) {
                if (window.matchMedia("(min-width: " + breakpoints[i] + "px)").matches) {
                    if ($(places[breakpoints[i]]).length) {
                        if (!$(this).next(places[breakpoints[i]]).length) {
                            $(this).attr("data-place-breakpoint", breakpoints[i]).insertBefore(places[breakpoints[i]]);
                        }
                    }
                    break;
                }
            }
        });

        $("body").trigger("responsive-update");

        $("body").data("ww", ww);
    }
    if (typeof no_animation !== 'undefined' && no_animation) {
        $("body")[0].offsetHeight;
        $("body").removeClass('no-transition no-animation');
    }
}


/*

Scroll Lazy Loading

 */

function blazy_init() {

    $('.js-blazy-revalidate-on-scroll').on('scroll', function () {
        blazy_revalidate_on_scroll_delay(function () {
            if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
                Blazy.revalidate();
            }
        }, 50);
    });

    window.Blazy = new Blazy({
        offset: 0,
        success: function (ele) {
            var $o = $(ele).closest(".img-to-bg");
            img_to_bg($o);
            $o.addClass('img-to-bg-lazy-loaded');
            //console.log('Blazy', ele, 'success');
            blazy_callback(ele);
        }
        , error: function (ele, msg) {
            //console.log('Blazy', ele, msg);
            blazy_callback(ele);
            if (msg === 'missing') {
                //console.log(ele, msg);
            } else if (msg === 'invalid') {
                //console.log(ele, msg);
            }
        }
    });

    $(window).on('resize', function () {
        blazy_revalidate_delay(function () {
            blazy_revalidate();
        }, 100);
    });

    $(document).on('shown.bs.modal', function () {
        blazy_revalidate();
    });

    $('.js-slick-slider-revalidate-image').on('init reInit setPosition', function (event) {
        blazy_revalidate();
    });
}

function blazy_callback(ele) {
    var callback = $(ele).not('.blazy-callback-executed').data('src-callback');
    if (callback) {
        var callback_params = $(ele).data('src-callback-params');
        if (!callback_params) {
            callback_params = [];
        }
        var fn = getFunctionFromString(callback);
        if (typeof fn === "function") {
            $(ele).addClass('blazy-callback-executed');
            fn.apply(ele, callback_params);
        }
    }
}

function blazy_revalidate() {
    if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
        Blazy.revalidate();
    }
}

var blazy_revalidate_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

var blazy_revalidate_on_scroll_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();

// Get function from string, with or without scopes (by Nicolas Gauthier)
window.getFunctionFromString = function (string) {
    var scope = window;
    var scopeSplit = string.split('.');
    for (i = 0; i < scopeSplit.length - 1; i++) {
        scope = scope[scopeSplit[i]];

        if (scope == undefined) return;
    }

    return scope[scopeSplit[scopeSplit.length - 1]];
};


/*

Set Background Image depending on img content inside it

 */

function img_to_bg($o, context) {

    if (!$("body").hasClass("img-to-bg-inited")) {

        $(window).on("resize", function () {
            delay_img_to_bg(function () {
                img_to_bg($(".img-to-bg-resp"));
            }, 100);
        });

        $("body").addClass("img-to-bg-inited");
    }

    if (typeof $o === "undefined" || !$o) $o = $(".img-to-bg", context);
    $o.each(function () {
        var $imgtobg = $(this);
        var $img = $imgtobg.find("> img").first();
        if (!$img.length) {
            $img = $imgtobg.find("> picture img").first();
        }
        var src = "";
        if ($img.length) {
            var src = $img[0].currentSrc;
        }
        if (!src) {
            src = $img.attr('src');
        }
        if ($img.length && src) {
            $imgtobg.css("background-image", "url('" + src + "')");
            $imgtobg.addClass("img-to-bg--inited");
        }
    });
}

var delay_img_to_bg = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();


/*

Scroll to needed objects

 */

function goto_init() {

    if (location.hash && location.hash.length) {
        var $o = $(location.hash);
        var h = $('.js-goto-offset-on-load').not('.js-goto-offset').first().outerHeight();
        goto_object($o, 0, (h)?-1*h:0);
    }

    $(document).on("click", ".js-goto", function (e) {
        var href = $(this).attr("href");
        var hash = href.split('#');
        if (hash.length > 1) {
            hash = '#' + hash.pop();
            var $o = $(hash);
            if ($o.length) {
                e.preventDefault();
                var $this = $(this);
                if ($this.closest(".goto-list").length) {
                    $this.closest(".goto-list").find("li").removeClass("active");
                    $this.closest("li").addClass("active");
                    tabs_update_pointer($this.closest(".tabs"));
                }
                if ($this.closest(".goto-hash-change").length) {
                    location_hash_update($this.attr("href"));
                }
                goto_object($o);
            }
        }
    });
}

function goto_object($o, speed, doffset) {
    if (typeof speed === 'undefined') {
        speed = 700;
    }
    if ($o.length) {
        var offset = $o.offset().top;
        if (typeof doffset !== 'undefined') {
            offset += doffset;
        }
        var $offset = $(".js-goto-offset").first();
        if ($offset.length) {
            offset -= $offset.outerHeight();
        }
        if ($o.data("goto-offset-element")) {
            offset -= $($o.data("goto-offset-element")).outerHeight();
        }
        goto_offset(offset, speed, $o);
    }
}

function goto_offset(offset, speed, $o) {
    if (typeof speed === 'undefined') {
        speed = 700;
    }
    $("html, body").stop(true, true).animate({scrollTop: offset}, speed, function () {
        $(this).trigger('goto-end');
        if ($o) {
            $o.trigger('goto-end');
        }
    });
}


/*

Actions on Scroll

 */

function scroll_animations() {
    body_scrolled();
    scroll_activate();
}

function scroll_activate() {

    if (!$("body").hasClass("scroll-activate-inited")) {

        $(document).on('goto', '.js-scroll-activate a', function(){
            window['scroll-activate-locked'] = true;
            delay(function(){
                window['scroll-activate-locked'] = false;
            }, 800);
        });

        $("body").addClass("scroll-activate-inited");
    }

    var st = $(window).scrollTop();
    var $gtl = $(".js-scroll-activate");
    if ($gtl.length && !window['scroll-activate-locked']) {
        var $gtl_a = $gtl.find("a");
        var dh = $(".header").outerHeight();
        var t_offset = 0;
        if (st > t_offset) {
            var $active = false;
            var index = -1;
            $gtl_a.each(function(i) {
                var $this = $(this);
                var href = $(this).attr("href").split('#');
                if (href[1]) {
                    href = '#'+ href[1];
                }
                else {
                    return false;
                }
                if (href.length < 2) {
                    return false;
                }
                var $o = $(href);
                var o_h = $o.outerHeight();
                if (!o_h && $o.data('stop-element')) {
                    $o_s_e = $($o.data('stop-element'));
                    o_h = $o_s_e.offset().top - $o.offset().top;
                }
                if ($o.length && st + 0 /*$(window).height() / 3*/ >= $o.offset().top - dh && st + 0/*$(window).height() / 3*/ < $o.offset().top + o_h - dh) {
                    index = i;
                    $active = $this;
                    return false;
                }
            });
            if ($(".wrap").outerHeight() - $(window).height() - st < 100) {
                index = $gtl_a.length - 1;
                $active = $gtl_a.last();
            }
            if ($active && (typeof this.hmai === "undefined" || index != this.hmai)) {
                this.hmai = index;
                activate_goto_link($active);
            }
        } else {
            this.hmai = -1;
            activate_goto_link($gtl_a.first());
        }
    }
}

function activate_goto_link($obj) {
    $obj.addClass("active").siblings().removeClass("active")
        .end().parent("li").addClass("active").siblings().removeClass("active");
    $obj.trigger("link-activated");
}


function body_scrolled() {
    requestAnimationFrame(function () {
        var $o = $(".js-header-on-scroll");
        if ($o.length) {
            var st = $(window).scrollTop();
            var scrolled_condition = st > 0;
            var wh = window.innerHeight;
            if (scrolled_condition) {
                if (!$o.hasClass("scrolled")) $o.addClass("scrolled");
            } else {
                if ($o.hasClass("scrolled")) $o.removeClass("scrolled");
            }
            var scrolled_condition = st > wh;
            if (scrolled_condition) {
                if (!$o.hasClass("scrolled-fold")) $o.addClass("scrolled-fold");
            } else {
                if ($o.hasClass("scrolled-fold")) $o.removeClass("scrolled-fold");
            }
            scroll_back_header($o);
        }
    });
}

function scroll_back_header($o) {
    var y_offset = window.pageYOffset;
    this.menuScrolled = y_offset > 0;
    this.menuHidden = y_offset > $('.header-replace').height() && y_offset > this.oldScrollPosition;
    if (y_offset != this.oldScrollPosition) {
        $o.toggleClass("header--hidden", this.menuHidden);
        $o.toggleClass("header--scrolled", this.menuScrolled);
    }
    this.oldScrollPosition = y_offset;
}

function scroll_back_header_hide($o) {
    var y_offset = window.pageYOffset;
    this.menuHidden = y_offset > $('.header-replace').height();
    $o.toggleClass("header--hidden", this.menuHidden);
}


/*

Header Init

*/

function header_init() {

    $(document).on("click", ".js-menu-switcher", function (e) {
        e.preventDefault();
        $("html").toggleClass("menu-overlay-active");
        if ($("html").hasClass("menu-overlay-active")) {
            bodyScrollLock.disableBodyScroll($('.menu-overlay__content')[0]);
        } else {
            bodyScrollLock.enableBodyScroll($('.menu-overlay__content')[0]);
        }
    });

    $(document).on("click", ".js-menu-hide", function (e) {
        menu_overlay_hide();
    });

    $(document).on("click", "*", function (e) {
        if (!$(e.target).closest(".menu-overlay, .js-menu-switcher").length) {
            if ($("html").hasClass("menu-overlay-active")) {
                menu_overlay_hide();
            }
        }
    });

    $(document).on("touchmove", ".menu-overlay", function (e) {
        e.stopPropagation();
    });

    $(".menu-overlay__content").swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
            if (direction == 'up') {
                menu_overlay_hide();
            }
        },
        excludedElements: "",
        allowPageScroll: "vertical"
    });

    $(window).on("scroll", function (e) {
        if ($("html").hasClass("menu-overlay-active")) {
            menu_overlay_hide();
        }
    });
}

function menu_overlay_hide() {
    $("html").removeClass("menu-overlay-active");
    bodyScrollLock.enableBodyScroll($('.menu-overlay__content')[0]);
}


/*

Expanded Blocks Functionality

 */

function expand_it_init() {
    //expand_it_init_prepare(null, true);
    window['expand_it_window_width'] = $(window).width();
    $(window).on("resize", function () {
        if ($(this).width() != window['expand_it_window_width']) {
            expand_it_init_prepare(null, true);
            window['expand_it_window_width'] = $(this).width();
        }
    });

    $(document).on("click expand-it", ".expand-it", function (e) {
        if (!$(this).data('no-prevent-default')) {
            e.preventDefault();
        }
        var $o = $($(this).data("expand-selector"));
        if (!$o.length) {
            $o = $(this).closest(".expand-it-wrapper").find(".expand-it-container").eq(0);
        }
        if (!$o.length) {
            $o = $(this).closest(".expand-it-container");
        }
        if (!$o.length) {
            $o = $($(this).attr("href"));
        }
        if (!$o.length) return;

        expand_it_trigger($(this), $o, e.type === "expand-it");
    });

    $(document).on("-webkit-transitionend transitionend", ".expand-it-container", function (e) {
        var $o = $(e.target);
        if ($o.hasClass('expand-it-container')) {
            if ($o.hasClass("before-transition")) {
                expand_it_height_check($o);
            }
            expand_it_init_prepare($o.closest('.expand-it-container'), true);
            $(e.target).removeClass("before-transition");
            $(e.target).trigger("expandAfter");
        }
    });

    if (location.hash && location.hash.substr(0, 1).match(/\w/i)) {
        if ($(location.hash).filter(".expand-it-wrapper").length) {
            var $o = $(location.hash);
            var $loc_link = $(".expand-it[href='" + location.hash + "']");
            if (!$loc_link.length) {
                $loc_link = $o.filter(".expand-it-wrapper").find(".expand-it");
            }
            if ($loc_link.not(".active").filter(":visible").length) {
                setTimeout(function () {
                    $loc_link.trigger("click");
                }, 300)
            }
        }
    }

    $(document).on("expand-it-open", function (e) {
        if (typeof Blazy !== 'undefined' && typeof Blazy.revalidate !== 'undefined') {
            Blazy.revalidate();
        }
    });
}

function expand_it_height_check($o) {
    if ($o.hasClass("expand-it-container") && !$o.hasClass("expand-it-container-overflow-hidden")) {
        var height_default = 0;
        var current_height = parseInt($o.css("max-height"), 10);
        if ($o.find(".expand-it-container-height-default").length) {
            height_default = $o.find(".expand-it-container-height-default").height();
        }
        $o.toggleClass("overflow-visible", current_height > height_default);
    }
    if ($o.hasClass("expand-it-container") && $o.hasClass("expand-it-container-max-height-auto")) {
        var id = $o.attr("id");
        setTimeout(function () {
            removeCSSRule("rule-" + id);
        }, 300);
    }
}

function expand_it_trigger($handler, $o, soft) {

    var id = $o.attr("id");
    if (!id) {
        id = "id" + (new Date()).getTime() + $o.text().length;
        $o.attr("id", id);
    }
    expand_it_init_prepare($o, true);
    height = $o.find(".expand-it-inner").eq(0).outerHeight(true);
    $o[0].offsetHeight;
    $o.addClass("no-transition-only-this");
    $o[0].offsetHeight;
    if (!$o.hasClass("expand-it-container-overflow-hidden")) {
        $o.removeClass("overflow-visible");
    }
    if ($o.hasClass("active")) {
        $o.removeClass("overflow-visible");
    }
    $o[0].offsetHeight;
    $o.removeClass("no-transition-only-this");
    if (!$o.hasClass("active") && !$("#rule-" + id).length) {
        addCSSRule("rule-" + id, "#" + id + ".active { max-height: " + height + "px; }");
    }
    $o[0].offsetHeight;

    if ($handler.attr("data-label")) {
        var label = $handler.html();
        $handler.html($handler.attr("data-label"));
        $handler.attr("data-label", label);
    }
    $handler.toggleClass("active");
    $(".expand-it.active[href='#" + $o.attr("id") + "']").not($handler).toggleClass("active");

    var $wrapper = $o.closest(".expand-it-wrapper");

    if (!soft) {
        $o.trigger("expandBefore");
        $o.addClass("before-transition").toggleClass("active").siblings(".expand-it-container").each(function () {
            $(".expand-it.active[href='#" + $handler.attr("id") + "']").trigger("expand-it");
            $handler.addClass("before-transition").removeClass("active");
        });
        var is_active = $o.hasClass("active");
        $wrapper.toggleClass("active", is_active);
        if ($wrapper.hasClass("expand-it-wrapper-collapse-siblings")) {
            $wrapper.siblings(".expand-it-wrapper").each(function () {
                var $this = $(this).find(".expand-it-container").first();
                if ($(this).find(".expand-it").length) {
                    $(this).find(".expand-it.active").trigger("expand-it");
                } else {
                    var $this_other = $(".expand-it.active[href='#" + $this.attr("id") + "']");
                    if ($this_other.length) {
                        $this_other.trigger("expand-it");
                    } else {
                        var $this_other = $(this).find('.expand-it-pseudo')/*.filter(function() {
                            return $(this).parent($this).length === 0;
                        })*/;
                        if ($this_other.length) {
                            expand_it_trigger($this_other, $this, true);
                        }
                    }
                    if ($this_other.length) {
                        $this_other.removeClass("active");
                    }
                }
                $this.addClass("before-transition").removeClass("active");
                $(this).removeClass("active");
            });
        }
        if ($wrapper.hasClass("expand-it-wrapper-collapse-siblings") || $wrapper.hasClass("expand-it-wrapper-scroll-to")) {
            if (!$wrapper.hasClass("expand-it-wrapper-collapse-siblings") || $wrapper.hasClass("active")) {
                setTimeout(function () {
                    var $sticky = $(".js-goto-offset-expand");
                    var offset = 0;
                    if ($sticky.length) {
                        $sticky.each(function () {
                            offset = Math.max(offset, $sticky.outerHeight() + parseInt($sticky.css('top'), 10));
                        });
                    }
                    if ($wrapper.offset().top < $(window).scrollTop() + offset) {
                        goto_object($wrapper, 400, -1 * offset - parseInt($wrapper.css('margin-top'), 10));
                    }
                }, 400);
            }
        }
        if (($o.hasClass("active") || $o.hasClass("expand-it-container--scroll-to-always")) && $handler.hasClass("expand-it-scroll-to")) {
            goto_object($o, 500, 'easeInOutQuad');
        }
        if ($handler.hasClass("expand-it-hash-change")) {
            if (is_active) {
                if ($handler.attr("href")) {
                    location_hash_update($handler.attr("href"));
                } else if ($wrapper.attr("id")) {
                    location_hash_update("#" + $wrapper.attr("id"));
                }
            } else {
                var $tabpane = $handler.closest(".tab-pane");
                if ($tabpane.length && $tabpane.attr("id")) {
                    location_hash_update("#" + $tabpane.attr("id"));
                } else {
                    location_hash_remove();
                }
            }
        }
        $o.trigger('expand-it-' + ((is_active) ? 'open' : 'close'));
    }
}

function expand_it_init_prepare($c, force) {
    if (typeof $c === "undefined" || !$c) $c = $(".expand-it-container");
    if (!force) {
        $c = $c.not(".expand-it-container-prepared");
    }
    var rules = '';
    $c.each(function () {
        var $o = $(this);
        var id = $o.attr("id");
        if (!id) {
            id = "id" + (new Date()).getTime() + $o.text().length;
            $o.attr("id", id);
        }
        //height = $o.find(".expand-it-inner").outerHeight(true);
        height = $o.find(".expand-it-inner")[0].clientHeight;
        rules += " #" + id + ".active { max-height: " + height + "px; } ";
        $o.addClass("expand-it-container-prepared");
    });
    if (rules) {
        addCSSRule("rule-expand-it", rules);
    }
}


/*

Hide/Show blocks

 */

function toggle_element_init() {
    $(document).on("click click-pseudo change toggle-hide", ".toggle-element, .show-element, .hide-element", function (e) {
        if ($(this).is("a")) e.preventDefault();
        if (e.type != "change" && $(this).is(":checkbox,:radio")) {
            return true;
        }
        var $o = $();
        if ($(this).attr("href") && $(this).attr("href").length > 1) {
            $o = $($(this).attr("href"));
        }
        if (!$o.length) {
            $o = $($(this).data("selector"));
        }
        var restore_scroll = $(this).data("toggle-restore-scroll-position");
        if (restore_scroll) {
            var scroll_pos = $(window).scrollTop();
            var $scroll_relative = $(this);
            var scroll_relative = $(this).data('toggle-restore-scroll-relative');
            if (scroll_relative) {
                $scroll_relative = $(scroll_relative);
            }
            var offset_pos = parseInt($scroll_relative.offset().top, 10);
        }
        var class_name = "hidden";
        if ($(this).data("toggle-class")) {
            class_name = $(this).data("toggle-class");
        }
        var element_class_name = "active";
        if ($(this).data("toggle-element-class")) {
            element_class_name = $(this).data("toggle-element-class");
        }
        var change_label = false;
        if (($(this).hasClass("toggle-element") && e.type != "toggle-hide") || (e.type == "toggle-hide" && $o.hasClass(element_class_name))) {
            change_label = true;
            if ($(this).is(":checkbox,:radio")) {
                if (e.type == "change") {
                    $o.toggleClass(class_name, !$(this).prop("checked"));
                }
            } else {
                $(this).toggleClass(element_class_name);
                $o.toggleClass(class_name);
            }
            $o.data('toggle-class', class_name);
            $o.data('toggle-element-class', element_class_name);
            $o.data('toggle-element', $(this));
            $o.trigger("toggle-element");
        }
        if ($(this).data("toggle-close-other") && e.type != "toggle-hide") {
            var group = $(this).data("toggle-group");
            $('.toggle-element, .show-element').not(this).filter('[data-toggle-group="' + group + '"]').each(function () {
                $(this).trigger('toggle-hide');
            });
        }
        if ($(this).hasClass("show-element")) {
            $o_s = $($(this).data("selector-show"));
            if ($o_s.length) {
                $o = $o_s;
            }
            if (!$(this).hasClass(element_class_name)) change_label = true;
            $(this).addClass(element_class_name);
            $o.toggleClass(class_name, !!$(this).data("toggle-reverse"));
            $o.trigger("show-element");
        }
        if ($(this).hasClass("hide-element")) {
            $o_h = $($(this).data("selector-hide"));
            if ($o_h.length) {
                $o = $o_h;
            }
            if ($(this).hasClass(element_class_name)) change_label = true;
            $(this).addClass(element_class_name);
            $o.toggleClass(class_name, !$(this).data("toggle-reverse"));
            $o.trigger("hide-element");
        }
        if (change_label && $(this).data("toggle-change-label")) {
            var label = $(this).html();
            $(this).html($(this).attr("data-toggle-change-label"));
            $(this).attr("data-toggle-change-label", label);
        }
        var $siblings = $();
        if ($(this).data("toggle-siblings-selector")) {
            $siblings = $(this).closest($(this).data("toggle-siblings-selector")).siblings();
        }
        if ($(this).data("toggle-current-selector")) {
            $siblings = $siblings.find($(this).data("toggle-current-selector"));
        }
        if ($siblings.length) {
            $siblings.removeClass(element_class_name);
        }
        if (restore_scroll) {
            var scroll_pos_new = $(window).scrollTop();
            var offset_pos_new = parseInt($scroll_relative.offset().top, 10);
            $(window).scrollTop(offset_pos_new - (offset_pos - scroll_pos));
        }
    });

    $(document).on("click", "*", function (e) {
        toggle_element_close_on_blur_delay(function () {
            if (!$(e.target).closest(".toggle-element").length && !$(e.target).closest(".toggle-element-object").length) {
                $(".toggle-element-object[data-toggle-element-close-on-blur]").each(function () {
                    var classname = $(this).data('toggle-class');
                    if (!classname) classname = 'hidden';
                    $(this).removeClass(classname);
                    $(this).trigger("toggle-element");
                    if ($(this).data('toggle-element')) {
                        $($(this).data('toggle-element')).removeClass($(this).data('toggle-element-class'));
                    }
                });
            }
        }, 0);
    });
}

var toggle_element_close_on_blur_delay = (function () {
    var timer = 0;
    return function (callback, ms) {
        clearTimeout(timer);
        timer = setTimeout(callback, ms);
    };
})();


function misc_init() {

    $(document).on('show-element', function () {
        responsive_update(true);
    });

    $(document).on('change upload-clear', '.js-receipt .js-upload', function(e){
        var $form = $(this).closest('form');
        $form.find(".js-upload-submit").toggleClass('hidden', !this.files.length);
    });

    // $(document).on('change', '.js-wupload-form .js-upload', function(e){
    //     var $form = $(this).closest('form');
    //     $form.validate();
    // });

    $(document).on('change', '.js-wupload-form .js-upload-agree', function(e){
        var $form = $(this).closest('form');
        $form.find('.js-upload-agree').not(this).prop('checked', $(this).prop('checked')).trigger('change-pseudo');
    });

    $(document).on('click', '.js-wupload-form-to-start', function(e){
        var $form = $(this).closest('form');
        $form.removeClass('inactive');
    });

    $(document).on("after-action-success", ".js-wupload-form", function(e, response){
        var $form = $(this);
        var is_success = form_response_is_success($(this), response, $(this).data('response-success-match'));
        if (!response.errors) {
            $form.find('.js-upload').off('change.wupload-inactive-error');
            if ($form.hasClass('js-action-reset-after-wupload')) {
                $(this)[0].reset();
            }
            $(this).toggleClass('inactive-error', !is_success);
            setTimeout(function(){
                $form.find('.js-upload').one('change.wupload-inactive-error', function(e){
                    //console.log('change.wupload-inactive-error');
                    var $form = $(this).closest('form');
                    $form.removeClass('inactive inactive-error');
                });
            }, 1000);
        }
    });

    $(document).on("click", ".js-input-password-toggle", function (e) {
        e.preventDefault();
        var $input = $($(this).data('input-password'));
        if ($input.length) {
            var type = $input.attr('type');
            var state = type == 'password';
            $input.attr('type', state?'text':'password');
            $(this).find('.js-input-password-toggle-state-visible').toggleClass('hidden', state);
            $(this).find('.js-input-password-toggle-state-invisible').toggleClass('hidden', !state);
        }
    });

    $(document).on('keyup', '.js-multi-input input', function(e){
        var $c = $(this).closest('.js-multi-input');
        var $o = $($c.data('copy-to'));
        if ($o.length) {
            var val = '';
            var filled = true;
            $(this).parent().children('input').each(function(){
                val += $(this).val();
                if (!$(this).val().length) {
                    filled = false;
                }
            });
            $o.val(val);
            if (filled) {
                $o.trigger('change');
            }
            $(this).focus();
        }
        if ($(this).val().length >= $(this).attr('maxlength')) {
            $(this).next('input').focus();
        }
        if (e.which == 8 && !$(this).val().length) {
            $(this).prev('input').focus();
        }
    });


    $(document).on('click', '.js-upload-img-container-zoom > img', function(e){
        $.fancybox.open({
            src: $(this).attr('src')
        }, $.fancybox.options_default);
    });

    $(document).on("loading-end", ".js-upload-submit-on-load", function(e){
        var $form = $(this).closest('form');
        $form.trigger('submit');
    });


}


function upload_init() {

    $(document).on("change", ".js-upload", function (e) { // change
        e.preventDefault();
        var ts = (new Date()).getTime();
        var $o = $($(this).data('upload-container'));
        if (!$o.length) {
            $o = $(this).closest('.js-upload-container');
        }
        $(this).removeClass('loaded').trigger('loading-start');
        $o.removeClass('loaded');
        $o.find('.js-upload-img-container img').remove();
        if (this.files.length) {
            $(this).addClass('loading');
            $o.addClass('loading');
            $o.find('.js-upload-img-container').append('<img>');
            upload_load_image(this, $o.find('.js-upload-img-container img')[0]);
            var $this = $(this);
            var timeout = Math.max((new Date()).getTime() - ts, $this.data('upload-min-delay'));
            $o.find('.js-upload-progress').css({width: 0}).stop(true,true).animate({width: '100%'}, timeout);
            setTimeout(function(){
                $this.addClass('loaded').trigger('loading-end');
                $o.addClass('loaded');
                $this.removeClass('loading');
                $o.removeClass('loading');
                $this.blur();
            }, timeout);
        }
        // console.log('js-upload change');
    });

    $(document).on("click", ".js-upload-clear", function (e) { // change
        e.preventDefault();
        var $o = $(this).closest('.js-upload-container');
        var $input = $($o.data('upload-input'));
        if (!$input.length) {
            $input = $o.find('.js-upload');
        }
        upload_clear($input);
    });

    $(document).on("dragenter dragover", ".js-upload", function (e) {
        var $o = $(this).closest('.js-upload-container');
        $o.addClass('is-dragover');
    });

    $(document).on("dragleave drop", ".js-upload", function (e) {
        var $o = $(this).closest('.js-upload-container');
        $o.removeClass('is-dragover');
    });
};

function upload_clear(input) {
    var $input = $(input);
    var $o = $($input.data('upload-container'));
    if (!$o.length) {
        $o = $input.closest('.js-upload-container');
    }
    $input.each(function(i){
        var id = 'upload-clear-id'+(new Date()).getTime()+'-'+i;
        $(this).attr('data-upload-clear-id', id);
        $(this).replaceWith($('<div>').append($(this).clone()).html());
        $('[data-upload-clear-id="'+id+'"]').removeClass('loaded').trigger('upload-clear');
    });
    $o.removeClass('loaded');
    $o.find('.js-upload-img-name').text('');
};

function upload_load_image(input, img) {
    var input, file, fr, img;

    if (typeof window.FileReader !== 'function') {
        alert("The file API isn't supported on this browser yet.");
        return;
    }

    if (!input) {
        alert("Um, couldn't find the imgfile element.");
    }
    else if (!input.files) {
        alert("This browser doesn't seem to support the `files` property of file inputs.");
    }
    else if (!input.files[0]) {
        //alert("Please select a file.");
    }
    else {
        file = input.files[0];
        var accept = input.getAttribute('accept');
        if (!accept || file.type.indexOf(accept.split('*')[0]) === 0 || accept.indexOf(file.type) !== -1) {
            fr = new FileReader();
            fr.onload = createImage;
            fr.readAsDataURL(file);
            $(input).closest('.js-upload-container').find('.js-upload-img-name').text(input.files[0].name);
        }
        else {
            upload_clear(input);
        }
    }

    function createImage() {
        if (img) {
            img.onload = imageLoaded;
            img.src = fr.result;
            $(img).parent().css('background-image', fr.result);
        }
    }

    function imageLoaded() {

    }
};


function countdown_init($o, context) {
    if (typeof $o === "undefined" || !$o) {
        $o = context?$('.js-countdown', context):$('.js-countdown');
        $o = $o.not(".js-countdown-inited");
    }
    var lang = $('html').attr('lang');
    if (!lang) {
        lang = '';
    }
    $o.each(function(){
        var options = {};
        options = $.extend(options, $.countdown.regionalOptions[lang]);
        if ($(this).data('countdown')) {
            options = $.extend(options, $(this).data('countdown'));
        }
        if (typeof options['until'] === 'string') {
            var date = new Date();
            date.setTime(Date.parse(options['until']));
            options['until'] = date;
        }
        if (typeof options['since'] === 'string') {
            var date = new Date();
            date.setTime(Date.parse(options['since']));
            options['since'] = date;
        }
        $(this).countdown(options);
    });
}

function scountdown_init($o, context) {
    if (typeof $o === "undefined" || !$o) {
        $o = context?$('.js-scountdown', context):$('.js-scountdown');
        $o = $o.not(".js-scountdown-inited");
    }
    $o.each(function(){
        var duration = this.getAttribute('data-countdown');
        var timer = duration;
        setTimer(this, timer);
        startTimer(this, --timer);
    });

    function startTimer(element, duration) {
        var timer = duration, minutes, seconds;
        setInterval(function () {
            setTimer(element, timer);
            if (--timer < 0) {
                timer = duration;
            }
        }, 1000);
    }

    function setTimer(element, duration) {
        var minutes, seconds;
        minutes = parseInt(duration / 60, 10);
        seconds = parseInt(duration % 60, 10);
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;
        element.textContent = minutes + ":" + seconds;
    }

}